/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_No_SubscriptionInputs */

const en_settings_billing_no_subscription = /** @type {(inputs: Settings_Billing_No_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active subscription`)
};

/**
* | output |
* | --- |
* | "No active subscription" |
*
* @param {Settings_Billing_No_SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_no_subscription = /** @type {((inputs?: Settings_Billing_No_SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_No_SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_no_subscription(inputs)
});
export { settings_billing_no_subscription as "settings.billing.no_subscription" }